import onElementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElementExistRunOnce('.manual-task-show-page', () => {
  import('./internal/manual-task-show-page').then(({ default: Component }) => Component());
});

onElementExistRunOnce('.manual-task-field-map', () => {
  import('./internal/manual-task-field-maps').then(({ default: Component }) => Component());
});
